import React from 'react'
import { createRoot } from 'react-dom/client'
import store from '../store/store'
import { setOpen } from '../store/accountSlice'
import { Provider } from 'react-redux'
import Popup from "./Popup.jsx"
import Return from "./Return.jsx"
import InfoEdit from "./InfoEdit.jsx"

document.addEventListener('DOMContentLoaded', () => {
  const accountPop = document.querySelector('[data-account-popup]')
  
  if(accountPop) {
    const accountPopRoot = createRoot(accountPop)
    accountPopRoot.render(
      <Provider store={store}>
        <Popup />
      </Provider>
    )
  }

  const accountLinks = document.querySelectorAll(`[data-account-link]`)
  accountLinks.forEach(accountLink => {
    accountLink.addEventListener('click', (e) => {
      e.preventDefault()
      store.dispatch(setOpen(true))
    })
  })
  
  window.openAccountPopup = () => {
    store.dispatch(setOpen(true))
    setTimeout(() => {
      document.querySelector('#accountEmail').focus()
    }, 150)
  }

  window.initOrderReturn = (orderId, rootElement, reason, jsonData=null) => {
    window.returnPageRoot = createRoot(rootElement)
    let json = jsonData ? jsonData : JSON.parse(document.querySelector('[data-order-json]').innerHTML)
    window.returnPageRoot.render(<Return orderId={orderId} json={json} reason={reason} />)
  }
  window.removeOrderReturn = () => {
    window.returnPageRoot.unmount()
    if(document.querySelector('[data-section-type="main-order"]')) {
      document.querySelector('[data-section-type="main-order"]').classList.remove('!hidden')
    }
    if(document.querySelector('[data-section-type="customer-services"]')) {
      document.querySelector('[data-section-type="customer-services"]').classList.remove('!hidden')
    }
  }

  const infoEditBtn = document.querySelector('[data-info-edit]')
  if(infoEditBtn) {
    const infoForm = document.querySelector('[data-info-form]')
    const infoDetails = document.querySelector('[data-info-details]')
    infoEditBtn.addEventListener('click', () => {
      infoDetails.classList.add('!hidden')
      infoForm.classList.remove('!hidden')
    })

    const infoFormRoot = createRoot(infoForm)
    const infoInterval = setInterval(() => {
      if(typeof window.customerInfo != 'undefined' && window.customerInfo) {
        infoFormRoot.render(<InfoEdit customer={window.customerInfo} />)
        clearInterval(infoInterval)
      }
    }, 200)
  }
})